"use strict";

define('model/document.decision.category',['require','exports','module','./base'],function (require, exports, module) {
  var BaseModel = require('./base');
  var DocumentDecisionCategory = BaseModel.extend({
    urlRoot: '/rs/api/category',
    virtual: {
      labeledDescription: function labeledDescription() {
        return ['<strong>' + this.get('label') + '</strong>', this.get('description')].join('. ');
      }
    }
  }, {
    all: function all(decisionId, reviewOrDecisionType, policyName) {
      var urlPath = '/rs/api/category/:decisionId?reviewOrDecisionType=:reviewOrDecisionType&policyName=:policyName';
      return this.createCollection(urlPath).params({
        decisionId: decisionId,
        reviewOrDecisionType: reviewOrDecisionType,
        policyName: policyName
      });
    }
  });
  module.exports = DocumentDecisionCategory;
});

